import { Component, OnInit, ViewChild } from '@angular/core';
import { NotificationType } from 'src/app/models/notification.message';
import { EmployeeVm } from 'src/app/models/requests/employee-request';
import { EmployeesService } from 'src/app/services/employees.service';
import { NotificationService } from 'src/app/services/notification.service';
import { ContractsService } from 'src/app/services/contracts.service';
import { ContractDto } from 'src/app/models/contractDto';
import { SkillDto } from 'src/app/models/SkillDto';
import { Gender } from 'src/app/models/Gender';
import { contractorType } from 'src/app/models/ContractorType';
import { EmployeeRoleType } from 'src/app/models/EmployeeRoleType';
import { SkillsService } from 'src/app/services/skills.service';

@Component({
  selector: 'app-new-employee',
  templateUrl: './new-employee.component.html',
  styleUrls: ['./new-employee.component.css']
})
export class NewEmployeeComponent implements OnInit {

  Skills: SkillDto[] = [];
  Gender = Gender;
  EmployeeClass = contractorType;
  RoleType = EmployeeRoleType;
  @ViewChild('ngNewEmployeeForm') theForm: any;

  selectedSkillId: number = 0;
  selectedEmployeeClass: string = '';
  selectedRoleType: string = '';
  selectedGender: string = '';
  firstName: string = '';
  lastName: string = '';
  email: string = '';
  labourRate: number = 0;
  phoneNumber: number = 0;
  startDate: Date = new Date();
  endDate: Date = new Date();
  selectedContractId: number = 0;

  multipleEmployees: boolean = false;


  Contracts: ContractDto[] | undefined;

  constructor(private employeeService: EmployeesService, private contractsService: ContractsService,
    private notification: NotificationService, private skillService: SkillsService) { }

  ngOnInit(): void {

    // this.LoadDropDowns();
  }
  // async LoadDropDowns() {

  //   let resSkills = await this.skillService.getSkills().toPromise();
  //   this.Skills = <SkillDto[]>resSkills.responseData;

  //   let resContracts = await this.contractsService.getContractsValidforEmpcreation().toPromise();
  //   this.Contracts = <ContractDto[]>resContracts.responseData;
  //   ;

  // }
  // onSubmit(): void {

  //   let EmployeeVm: EmployeeVm = {
  //     firstName: this.firstName,
  //     lastName: this.lastName,
  //     email: this.email,
  //     skillId: this.selectedSkillId,
  //     phoneNumber: this.phoneNumber.toString(),
  //     gender: this.selectedGender,
  //     employeeClass: this.selectedEmployeeClass,
  //     roleType: this.selectedRoleType,
  //     startDate: this.startDate,
  //     endDate: this.endDate,
  //     contractId: this.selectedContractId,
  //     // contractNumber: ''
  //   };

  //   this.employeeService.saveEmployee(EmployeeVm).subscribe({
  //     next: (data => {
  //       
  //       if (data.responseCode == "00") {
  //         this.notification.sendMessage({
  //           message: data.message,
  //           type: NotificationType.success
  //         });

  //         console.debug(`Employee Created successfully ${data}`);
  //         this.theForm.resetForm();
  //       }
  //       else {

  //         this.notification.sendMessage({
  //           message: data.message,
  //           type: NotificationType.error
  //         });

  //       }

  //     }),
  //     error: ((error: any) => {
  //       console.log(error.error);
  //       ;


  //       this.notification.sendMessage({
  //         message: error.error.message,
  //         type: NotificationType.error
  //       });
  //     })

  //   });
  // };

  // uploadOption(): void {
  //   this.multipleEmployees = !this.multipleEmployees
  // }
}
